import { obterFornecedoresAsync } from "../../services/fornecedorService";

const CACHE_FORNECEDORES_MS = 60 * 60 * 1000;

const atualizarFornecedores = async ({ commit, state }, force = false) => {
    const listaCarregada = state.fornecedores && state.fornecedores.length > 0;
    const ultimaAtualizacao = state.ultimaAtualizacaoListaFornecedor;
    const cacheValido = ultimaAtualizacao &&
        Date.now() - new Date(ultimaAtualizacao).getTime() < CACHE_FORNECEDORES_MS;

    if (!force && listaCarregada && cacheValido) {
        return state.fornecedores;
    }

    const fornecedores = await obterFornecedoresAsync();
    commit('atualizarFornecedores', fornecedores);
    return fornecedores;
}

const atualizarFornecedor = ({ commit }, fornecedor) => {
    commit('atualizarFornecedor', fornecedor);
}

const addFornecedor = ({ commit }, fornecedor) => {
    commit('addFornecedor', fornecedor);
}

const updateFornecedor = ({ commit }, fornecedor) => {
    commit('updateFornecedor', fornecedor);
}

export default {
    atualizarFornecedores,
    atualizarFornecedor,
    addFornecedor,
    updateFornecedor
}
